import React, { ReactElement, useEffect, useState } from 'react';
import WPREST from '../../api/bestpark/wp-rest';
import PaymentMethods from 'assets/svgs/icon-cards.svg';
import BestCampLogoIcon from 'assets/svgs/logos/bestcamp-logo-with-icon.svg';
import FacebookIcon from 'assets/svgs/icon-facebook.svg';
import InstagramIcon from 'assets/svgs/icon-instagram.svg';
import YoutubeIcon from 'assets/svgs/icon-youtube.svg';

import './footer.scss';
import { useTranslate } from 'hooks/translate';

export default function Footer(): ReactElement {
  const [footerItems, setFooterItems] = useState<FooterItems | null>(null);
  const { t, locale } = useTranslate();

  interface FooterItems {
    socials: Socials;
    details: Details;
  }

  interface Socials {
    facebook?: string;
    instagram?: string;
    youtube?: string;
  }

  interface Details {
    company_name?: string;
    address?: string;
    email?: string;
    phone?: string;
  }

  useEffect(() => {
    // Get footer items from WP
    WPREST({
      method: 'get',
      url: `/info?lang=${locale}`,
    }).then((response) => {
      setFooterItems(response);
    });
  }, [locale]);

  const wordpressLink = `${process.env.REACT_APP_BESTCAMP_WP}/${locale}`;

  return (
    <footer>
      <div className='footer-container'>
        <div className='contact-container'>
          <div className='footer-col'>
            <a href={wordpressLink}>
              <img src={BestCampLogoIcon} alt='BestCamp' />
            </a>
          </div>
          <div className='footer-col'>
            <h3>{footerItems?.details?.company_name}</h3>
            <address>{footerItems?.details?.address}</address>
            <p>
              <a href={`mailto:${footerItems?.details?.email}`}>
                {footerItems?.details?.email}
              </a>
            </p>
          </div>
          <div className='footer-col'>
            <p className='footer-phone'>{t('landing_page.footer.phone')}</p>
            <h3>
              <a href={`tel:${footerItems?.details?.phone}`}>
                {`${footerItems?.details?.phone}`}
              </a>
            </h3>
            <p className='links'>
              <a href={`${wordpressLink}/privacy-policy/`}>
                {t('landing_page.footer.privacy')}
              </a>
            </p>

            <p className='links'>
              <a href={`${wordpressLink}/terms-of-delivery/`}>
                {t('landing_page.footer.terms_of_delivery')}
              </a>
            </p>
          </div>
          <div className='footer-col'>
            <div className='footer-icons'>
              {footerItems?.socials?.facebook && (
                <a
                  href={footerItems?.socials?.facebook}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img src={FacebookIcon} alt='Facebook Icon' />
                </a>
              )}
              {footerItems?.socials?.instagram && (
                <a
                  href={footerItems?.socials?.instagram}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img src={InstagramIcon} alt='Instagram Icon' />
                </a>
              )}
              {footerItems?.socials?.youtube && (
                <a
                  href={footerItems?.socials?.youtube}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img src={YoutubeIcon} alt='Youtube Icon' />
                </a>
              )}
            </div>
            <img src={PaymentMethods} alt='Payment Methods' />
          </div>
          <div className='footer-col' />
        </div>
        <div className='copyright-container'>
          <p>&copy; {new Date().getFullYear()} Best Camp</p>
        </div>
      </div>
    </footer>
  );
}
